module.exports = __webpack_public_path__ + "img/cap_export.95ebd338.jpg";